import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-12",
  "use": "icon-icon-nav-12-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-12\"><path d=\"M160 594.816h165.632V429.184H160v165.632z m0 207.04h165.632V636.224H160v165.632z m0-414.08h165.632V222.08H160v165.632z m207.04 207.04H864V429.184H367.04v165.632z m0 207.04H864V636.224H367.04v165.632z m0-579.712v165.632H864V222.08H367.04z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-12.svg
// module id = rhTd
// module chunks = 3